import JoinModal from './JoinModal'

export default JoinModal
